import { Route, Routes } from "react-router-dom"
import { RequireAuth } from "../contexts/AuthProvider/RequireAuth"
import { Usuario } from "../pages/Usuario"
import { Grupo } from "../pages/Grupo"
import { CredenciaisLooker } from "../pages/CredenciaisLooker"
import { Dashboard } from "../pages/Dashboard"
import { GrupoEmpresa } from "../pages/Grupo/GrupoEmpresa"
import { Categoria } from "../pages/Anomalias/Categoria"
import { Causa } from "../pages/Anomalias/Causa"

export const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<RequireAuth><Dashboard /></RequireAuth>} />
            <Route path="/usuario" element={<RequireAuth><Usuario /></RequireAuth>} />
            <Route path="/grupo" element={<RequireAuth><Grupo /></RequireAuth>} />
            <Route path="/grupoempresa" element={<RequireAuth><GrupoEmpresa /></RequireAuth>} />
            <Route path="/querylooker" element={<RequireAuth><CredenciaisLooker /></RequireAuth>} />
            <Route path="/categoria" element={<RequireAuth><Categoria /></RequireAuth>} />
            <Route path="/causa" element={<RequireAuth><Causa /></RequireAuth>} />
        </Routes>
    )
}